export type FeedbackCategory = "box_os" | "marketing" | "smartlev" | "training";

export const FEEDBACK_CATEGORIES: FeedbackCategory[] = [
  "box_os",
  "marketing",
  "smartlev",
  "training",
];

export interface FeedbackSubmission {
  category: FeedbackCategory;
  title: string;
  description: string;
  pageUrl?: string;
  screenshots: File[];
}

export interface FeedbackResponse {
  id: string;
  identifier: string;
  url: string;
  attachmentCount: number;
}
